import { useEffect, useState } from "react";
import heroBanner from "../../assets/images/pages/8-hour-idi.png";
import ShellCard from "../../components/ShellCard.jsx";
import PackageCard from "../../components/PackageCard";

const DrivingLessons = () => {
  const [hoveredCardId, setHoveredCardId] = useState(null);
  useEffect(() => {
    document.title = "Behind the Wheel Driving Lessons - Metro Traffic School";
  }, []);

  const courses = [
    {
      id: 1,
      titleLines: ["2-Hours"],
      price: "$199",
      description:
        "Dual Controlled Vehicles\n\nFree Pickups\n\nWeekday or Weekend Lessons",
      registerUrl: "https://driving.metrotrafficschool.com/book/8",
    },
    {
      id: 2,
      titleLines: ["4-Hours"],
      price: "$379",
      description:
        "Dual Controlled Vehicles\n\nFree Pickups\n\nWeekday or Weekend Lessons",
      registerUrl: "https://driving.metrotrafficschool.com/book/9",
    },
    {
      id: 3,
      titleLines: ["6-Hours"],
      price: "$539",
      description:
        "Dual Controlled Vehicles\n\nFree Pickups\n\nWeekday or Weekend Lessons\n\nDMV Test*",
      registerUrl: "https://driving.metrotrafficschool.com/book/10",
    },
    {
      id: 4,
      titleLines: ["8-Hours"],
      price: "$679",
      description:
        "Dual Controlled Vehicles\n\nFree Pickups\n\nWeekday or Weekend Lessons\n\nDMV Test*\n\nHighway Training",
      registerUrl: "https://driving.metrotrafficschool.com/book/11",
    },
    {
      id: 5,
      titleLines: ["10-Hours"],
      price: "$799",
      description:
        "Dual Controlled Vehicles\n\nFree Pickups\n\nWeekday or Weekend Lessons\n\nDMV Test*\n\nHighway Training\n\nDefensive Driving",
      registerUrl: "https://driving.metrotrafficschool.com/book/12",
    },
    {
      id: 6,
      titleLines: ["12-Hours"],
      price: "$899",
      description:
        "Dual Controlled Vehicles\n\nFree Pickups\n\nWeekday or Weekend Lessons\n\nDMV Test*\n\nHighway Training\n\nDefensive Driving",
      registerUrl: "https://driving.metrotrafficschool.com/book/13",
    },
  ];

  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            background: `url(${heroBanner})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">Behind the Wheel Driving Lessons</h1>
              <p className="banner-subheading">Metro Traffic School</p>
            </div>
          </div>
        </div>
      </section>

      <section className="online-traffic-school-page container pt-5">
        <div className="row g-4">
          {courses.map((c) => (
            <div className="col-12 col-sm-6 col-lg-4" key={c.id}>
              <PackageCard
                pkg={{
                  ...c,
                  registerLink: c.registerUrl,
                  description: (
                    <div style={{ whiteSpace: "pre-line" }}>
                      {c.description}
                    </div>
                  ),
                }}
                hoveredCardId={hoveredCardId}
                setHoveredCardId={setHoveredCardId}
                registerText="Register"
              />
            </div>
          ))}
        </div>

        <div className="container row py-5">
          <div className="col-12">
            <p className="text-white mb-0 p-3">
              *If the Instructor determines the student is ready for the DMV
              Test, part of the hours included in the package can be used to
              take the DMV test in our car. Includes pick up and drop off the
              day of the scheduled appointment.
            </p>
          </div>
        </div>
      </section>

      <section className="container pb-5">
        <div className="row">
          <div className="col-12">
            <ShellCard>
              <div className="row">
                <div className="col-12">
                  <div className="mb-4">
                    <h5 className="mb-3 fw-bold" style={{ color: "var(--metro-yellow)" }}>
                      Why Metro Traffic School?
                    </h5>
                    <p className="lh-lg" style={{ color: "#fff" }}>
                      In order to attain our goal of creating a safer world, we
                      strongly believe the first step is to develop safe driving
                      habits from the beginning. Metro Driving School's
                      commitment to developing safe driver's, starts by
                      providing the best driving lesson available. All our
                      instructors are experienced and go through a rigorous
                      certification process. Our vehicles are all newer models,
                      dual controlled, and continually inspected to ensure they
                      meet our standards of excellence.
                    </p>
                    <p className="lh-lg" style={{ color: "#fff" }}>
                      By completing driving lessons with Metro, not only will
                      you be provided the opportunity to take the DMV exam with
                      the same vehicle you completed your lessons with, you may
                      also qualify for a significant insurance discount. Metro
                      Driving School is recognized state-wide for its value and
                      commitment to safety. Therefore, by completing one of our
                      Programs, most major insurance companies will provide you
                      with a better insurance premium for completing our drivers
                      education program.
                    </p>
                    <p className="lh-lg" style={{ color: "#fff" }}>
                      We stand behind every program and on the off chance you
                      are not completely satisfied with your experience at Metro
                      Traffic School, please give us a call so we can ensure all
                      future experiences are nothing short of excellent. Our
                      dedicated customer services representatives will be with
                      you every step of the way to ensure you not only obtain
                      the driving experience you deserve, but also are one step
                      closer to passing your driving test on the first try and
                      becoming a better defensive driver.
                    </p>
                  </div>
                </div>
              </div>
            </ShellCard>
          </div>
        </div>
      </section>
    </>
  );
};

export default DrivingLessons;
